export class DataSettingsIput {
    schemaName: string;
    tableName: string;
    status: string;
}


export class DataSettingsOutput {
    schemaNameList: SchemaNameDet[];
    tableNamesList: TableNamesDet[];
    tableStructure: TableDetails[];
}

export class SchemaNameDet {
    schema_name: string;
    schema_id: number;
    schema_owner: string;
}

export class TableNamesDet {
    table_name: string;
}

export class TableDetails {
    COLUMN_NAME: string;
    IS_NULLABLE: string;
    DATA_TYPE: string;
    CHARACTER_MAXIMUM_LENGTH: string;
    NUMERIC_PRECISION: string;
}

export class DynamicInputTable {
    dynamicTableId: number;
    dynamicTableGroup: string;
    dynamicTableName: string;
}
export class ManualInputDataField {
    fieldName: string;
    caption: string;
    color: string; 
}

export class ManualInputDataFieldNew {
    dataField: string;
    caption: string;
    dataType: string;
    format: string
}

export class DynamicTablesWithCaptions {
    fields: ManualInputDataField[];
    values: DynamicInputTable[];
}

export class ManualInputData {
    manualInputName: string;
    isWait: string;
    errorLog: string;
    orderby: number;
    status: string; 
    userName: string;
    lastStartTime: Date | number | string;
    lastEndTime: Date | number | string;
    manualId: number;
    executionMaxTime: number;
    curentTime: number; 
    parameters: string;
    parametersDeclaration: string; 
    isParameters:boolean;
    isStop:boolean;
    manualInputGroup:string;
    isEnableStopButton:boolean;
}

export class ListCaption {
    field: string;
    caption: string;
    keyField: boolean;
    userEdit: boolean;
    dataType: string;
    orderBy: number;
    color: string; 
}

export class ManualInputDataUpdate {
    listData: ManualInputData[];
    listCaption: ListCaption[];
}

export class DyanmicInputUpdate {
    parameters: string;
    parametersDeclaration: string;
    id: number; 
} 

export class ManualInputStatus {
    status: string;
    manualId: number;
    isStop:boolean;
    executionMaxTime: number;
    curentTime: number; 
}
